import { Navigate } from 'react-router';
import type { ReactNode } from 'react';
import { useAuth } from '@/context/AuthContext';

interface Props {
  children: ReactNode;
}

export function RequireAdmin({ children }: Props) {
  const { loading, user, isAdmin } = useAuth();

  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (!isAdmin) return <Navigate to="/forbidden" replace />;

  return children;
}
